import React, { useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../mock/mock";

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const perView = 3;
  const maxIndex = Math.max(0, testimonials.length - perView);
  const next = useCallback(() => setIndex((i) => (i >= maxIndex ? 0 : i + 1)), [maxIndex]);
  const prev = () => setIndex((i) => (i <= 0 ? maxIndex : i - 1));
  useEffect(() => {
    const t = setInterval(next, 4800);
    return () => clearInterval(t);
  }, [next]);
  const initials = (name) => name.split(" ").map((w) => w[0]).slice(0, 2).join("");

  return (
    <section className="section-pad bg-white border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="eyebrow text-neutral-500">/ Testimonials</p>
            <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
              What Clients <span className="hl">Say</span>
            </h2>
          </div>
          <div className="flex gap-3">
            <button onClick={prev} className="w-12 h-12 border-2 border-[#0A0A0A] flex items-center justify-center hover:bg-[#0A0A0A] hover:text-[#F4F1EA] transition-colors">
              <ChevronLeft size={20} />
            </button>
            <button onClick={next} className="w-12 h-12 border-2 border-[#0A0A0A] flex items-center justify-center hover:bg-[#0A0A0A] hover:text-[#F4F1EA] transition-colors">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="overflow-hidden">
          <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${index * (100 / perView)}%)` }}>
            {testimonials.map((t) => (
              <div key={t.name} className="w-full md:w-1/2 lg:w-1/3 shrink-0 px-3">
                <div className="h-full border-2 border-[#0A0A0A] bg-[#F4F1EA] p-7 flex flex-col">
                  <span className="display text-6xl font-extrabold leading-none mb-3">“</span>
                  <p className="text-neutral-800 leading-relaxed mb-6 flex-1">{t.text}</p>
                  <div className="flex items-center gap-3 pt-4 border-t-2 border-[#0A0A0A]">
                    <div className="w-11 h-11 border-2 border-[#0A0A0A] bg-[#0A0A0A] text-[#F4F1EA] flex items-center justify-center mono font-bold text-sm">
                      {initials(t.name)}
                    </div>
                    <div>
                      <p className="display font-bold text-sm uppercase">{t.name}</p>
                      <p className="mono text-[11px] uppercase tracking-wide text-neutral-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
